import React, { useEffect, useState} from 'react';

import { Button } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import * as RestService from '../../services/eisRest';
//import CustomSelect from '../../components/custom-select/CustomSelect';
import NumberFormat from 'react-number-format';

//import WorkOrderModalWithDatatable from '../wrRouteTemplate/WrRouteTemplateModalWithDatatable';
import DocumentWorkOrderOperation from './DocumentWorkOrderOperation';





const DocumentWorkOrderTab = (props) => {

    
    const [t] = useTranslation();           
    
    
    const [workOrderDocument, setWorkOrderDocument] = useState();             
    const [operationList, setOperationList] = useState([]);
  //  const [checkTime, setCheckTime] = useState([]);    
    const [transactionType, setTransactionType] = useState(null);
    const [showWorkOrderModalWithDatatable, setShowWorkOrderModalWithDatatable] = useState(false);
    const [workOrder, setWorkOrder] = useState();   
    const [checkTime, setCheckTime] = useState([]);
 //   const [visibleWorkOrderNbr, setVisibleWorkOrderNbr] = useState(false);
      
    const [totalDurationMachine, setTotalDurationMachine] = useState(0);
    const [totalCostMachine, setTotalCostMachine] = useState(0);
    const [totalDurationOperator, setTotalDurationOperator] = useState(0);
    const [totalCostOperator, setTotalCostOperator] = useState(0);
    const [bomCost, setBomCost] = useState(0);
    
 
    const transactionOptions = [
     // { value: 'RCT-PO', label: 'Receive operations from suppliers by invoice or other method' },
     // { value: 'ISS-SO', label: 'Issue operations to customers by invoice' },
     // { value: 'RCT-WO', label: t('workOrder.label.RCT-WO') }
      { value: 'ISS-WO', label: t('workOrder.label.ISS-WO') }           
     
      
    ];
  
    const emptyOperation = {    
      lineNumber: 0,
      active: true, 
      id: '',
      name: '',    
      nbr: 0,
      resourceId: '',
      machineName: '',
      numOfMachines: 0,
      costPerHourMachine: 0,
      durationMachine: 0,
      costMachine: 0,
      workPositionId: '',
      workPositionName: '',
      numOfOperators: 0,
      costPerHourOperator: 0,
      durationOperator: 0,
      costOperator: 0,
      description: '', 
      divideAmongPcs: false     
    };

   

    const getWorkOrder = (id) => {
      RestService.callAnyApi('workOrder/getWorkOrder?id='+id, null)
      .then((data) => {
            setWorkOrder(data);  
            data.workOrderItems && data.workOrderItems.length !== 0 ? setOperationList(data.workOrderItems) : setOperationList(data.wrRouteTemplate.wrRouteTemplateItems) ;     
            RestService.callAnyApi('workOrder/getBomCost?bomId='+data.wrRouteTemplate.bomId+"&warehouseId="+data.wrRouteTemplate.warehouseId, null).then((data) => { 
            setBomCost(data);  
        })
        .catch((error) => {});     
        formik.setFieldValue('workOrderNbr',data.nbr);       
      })
      .catch((error) => {
        console.log(error);
      });
    }

    useEffect(() => {   
     
      setWorkOrderDocument(null);
      setTotalDurationMachine(0);
      setTotalCostMachine(0);
      setTotalDurationOperator(0);
      setTotalCostOperator(0);
      setBomCost(0);
      getWorkOrder(props.selectedRecord);
    }, [props.selectedRecord])


   

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    
          name: workOrder ? workOrder.name : '',
          nbr: workOrder ? workOrder.nbr : '',
          articleName: workOrder && workOrder.article ? workOrder.article.name : '',
          articleNbr: workOrder && workOrder.article ? workOrder.article.nbr : '',
          upperDescription: workOrder ? workOrder.upperDescription : '',
          lowerDescription: workOrder ? workOrder.lowerDescription : ''
      
      },
      validationSchema: Yup.object({
      //   firstName: Yup.string()   
     //     .nullable()  
      //    .required(t('general.message.required')),
      
      }),
      onSubmit: (values) => {           
          save('workOrder/saveWorkOrder',values);         
      }
      
    });
    
    useEffect(() => { 
     
    }, [])


    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
      workOrder.id = props.selectedRecord;
      workOrder.upperDescription = values.upperDescription;
      workOrder.lowerDescription = values.lowerDescription;
      workOrder.workOrderItems = operationList;

      RestService.callAnyApi(url,workOrder)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          setWorkOrder(data.responseObject); 
                          setOperationList(data.responseObject.workOrderItems);
                         // props.parentCallback(data.responseObject);
                          toast.success(t('general.message.saveSucceed'));                                                                      
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    }

   


    const clearForm = () => {
      setOperationList([])    
      setTotalDurationMachine(0);
      setTotalCostMachine(0);
      setTotalDurationOperator(0);
      setTotalCostOperator(0);
      setBomCost(0);
      formik.setFieldValue("upperDescription","");
      formik.setFieldValue("lowerDescription","");   
      
    }
    
    const addEmptyOperation = () => {      
      
      let num=0;
      operationList.map((operation,index) => {
        operation.active=false;
        if(operation.lineNumber>num){num=operation.lineNumber;}
      });
   //   emptyOperation.id = Date.now();
      emptyOperation.lineNumber = num+1; //operationList.length+1;



      emptyOperation.lineNumber = num+1;
      setOperationList([...operationList, emptyOperation]);
      
    }

    const operationCallback = (operationA,action) => {
       
      let num=0;
      operationList.map((operation,index) => {      
        if(operation.lineNumber>num){num=operation.lineNumber;}
      });

       if(action==='edit'){
        operationList.map((operation,index) => {
          if(operationA.lineNumber===operation.lineNumber){
            //operation = operationA;            
            operation.active=true;
                                 
          }else{
            operation.active=false;
          }
          
        });
      }

        if(action==='delete'){              
          const newList = operationList.filter((operation) => operation.lineNumber  !== operationA.lineNumber );
          if(newList.length>0){
            setOperationList(newList);
            
          }else{
            setOperationList([]);            
          }
          countTotalAmount(newList);
        }
        
        if(action==='copy'){
         
          operationList.map((operation,index) => {           
              operation.active=false;                      
          });
          const operationC = JSON.parse(JSON.stringify(operationA));
          operationC.lineNumber=num+1;
          operationC.active=true;        
          setOperationList([...operationList,operationC]);
          countTotalAmount(operationList);
        }

        if(action!='copy' && action!='delete'){
          setOperationList([...operationList]);
          countTotalAmount(operationList);
        }
       
       // setActiveOperation(index);
    }

 
    const countTotalAmount = (operationList) => {

      let totalTotalDurationMachineTemp=0;
      let totalTotalCostMachineTemp=0;
      let totalTotalDurationOperatorTemp=0;
      let totalTotalCostOperatorTemp=0;

      if(operationList.length>0){
        operationList.map((item,index) => {          
            totalTotalDurationMachineTemp+=item.durationMachine;
            totalTotalCostMachineTemp+=item.costMachine;
            totalTotalDurationOperatorTemp+=item.durationOperator;
            totalTotalCostOperatorTemp+=item.costOperator;
         });
      }
      setTotalDurationMachine(totalTotalDurationMachineTemp);
      setTotalCostMachine(totalTotalCostMachineTemp);
      setTotalDurationOperator(totalTotalDurationOperatorTemp);
      setTotalCostOperator(totalTotalCostOperatorTemp);
    }

    const getOperations = operationList.sort((a, b) => a.lineNumber > b.lineNumber ? 1 : -1).map((operation,index) => {
    
      return (
      <DocumentWorkOrderOperation  
        parentCallback={operationCallback}
        operation={operation}
        active={operation ? operation.active : false}
        checkTime={checkTime}
        bomId={workOrder ? workOrder.wrRouteTemplate.bomId : ''}
        divideAmongPcs={operation ? operation.divideAmongPcs : false}
      />
      )
    });

 

    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
                      <form onSubmit={formik.handleSubmit}>     
                    
                      <div className="row"> 
                                <div className="col-3 col-sm-3 col-lg-3">
                                  <div className="form-group">
                                    <label>{t('workOrder.label.workOrderNbr')}</label>
                                    <input type="text" class="form-control" readOnly placeholder="" {...formik.getFieldProps('nbr')} />
                                  </div>                                  
                                </div>        


                                <div className="col-3 col-sm-3 col-lg-3">
                                  <div className="form-group">
                                    <label>{t('article.label.article')}</label>
                                    <input type="text" class="form-control" readOnly placeholder="" {...formik.getFieldProps('articleName')} />
                                  </div>                                  
                                </div> 


                                <div className="col-3 col-sm-3 col-lg-3">
                                  <div className="form-group">
                                    <label>{t('article.label.articleNumber')}</label>
                                    <input type="text" class="form-control" readOnly placeholder="" {...formik.getFieldProps('articleNbr')} />
                                  </div>                                  
                                </div> 
                      
                      
                      </div>
    					      					  	 
    					        <div className="row text-muted">
    					  	  
		    					          	<div className="col-6 col-sm-6 col-lg-6">
    					  	  		          <input type="text" className="form-control col-12 col-sm-12 col-lg-12" {...formik.getFieldProps('upperDescription')}  placeholder={t('document.label.upperDescription')} />
    					  	  		      </div>    					  	  		
                			</div>

    					  	
    					  	    <div className="row text-muted" style={{marginLeft: '1px', marginRight: '1px', marginTop: '5px', fontSize: '13px', backgroundColor: '#e3e3e3', borderRadius: '5px'}}>
    					  	 
    					  	  	    	<div className="col-3 col-sm-3 col-lg-3">{t('workOrder.label.operation')+"/"+t('workOrder.label.machine')+"/"+t('workOrder.label.operator')}</div>
                            <div className="col-1 col-sm-1 col-lg-1">{t('workOrder.label.numberShort')}</div>                                                      
                            <div className="col-1 col-sm-1 col-lg-1">{t('workOrder.label.numOfMachines')}</div>
    					  	  		    <div className="col-1 col-sm-1 col-lg-1">{t('workOrder.label.durationMachine')}</div>
                            <div className="col-1 col-sm-1 col-lg-1">{t('workOrder.label.costMachine')}</div>                                                      
                            <div className="col-1 col-sm-1 col-lg-1">{t('workOrder.label.numOfOperators')}</div>
                            <div className="col-1 col-sm-1 col-lg-1">{t('workOrder.label.durationOperator')}</div>
                            <div className="col-1 col-sm-1 col-lg-1">{t('workOrder.label.costOperator')}</div>    					  	  		    
                            <div className="col-1 col-sm-1 col-lg-1">{t('workOrder.label.divideIntoPcs')}</div> 
    					  	  		    <div className="col-1 col-sm-1 col-lg-1" style={{textAlign: 'left'}}>{t('document.label.actions')}</div>				

                			</div>

             
                			<div className="row text-muted" style={{marginTop: '5px'}}></div>
    					  	 
    					  	         
                                {getOperations}                                 
                			     
    					  	  
                			<div className="row" style={{marginTop: '10px'}}>
    				              
                      	  	  	<div className="col-12 col-sm-12 col-lg-12">    					  	  		
                                      <button type="button" className="btn btn-default" onClick={addEmptyOperation}><i className="fas fa-plus"></i></button>
    					  	  	          </div>

    					  	    </div>


                      <div className="row">
                    
    					  	  					                
                                       <div className="col-3 col-sm-3 col-lg-3" style={{fontWeight: 'bold',marginTop: '7px', textAlign: 'right'}}>{t('workOrder.label.bomCost')}:</div>    					  	  	    					  	  					               
                                       <div className="col-1 col-sm-1 col-lg-1">
                                           <NumberFormat displayType="text" className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="2" thousandSeparator="." decimalSeparator="," suffix={' €'} value={bomCost} />                                            
                                       </div>

                                       <div className="col-1 col-sm-1 col-lg-1" style={{fontWeight: 'bold',marginTop: '7px', textAlign: 'right'}}>{t('document.label.total')}:</div>    					  	  	    					  	  					               
                                       <div className="col-1 col-sm-1 col-lg-1">
                                           <NumberFormat displayType="text" className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="2" thousandSeparator="." decimalSeparator="," suffix={' min.'} value={totalDurationMachine} />                                            
                                       </div>
                                       <div className="col-1 col-sm-1 col-lg-1">
                                           <NumberFormat displayType="text" className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="2" thousandSeparator="." decimalSeparator="," suffix={' €'} value={totalCostMachine} />                                            
                                       </div>
                                       <div className="col-1 col-sm-1 col-lg-1">
                                           
                                       </div>
                                       <div className="col-1 col-sm-1 col-lg-1">
                                           <NumberFormat displayType="text" className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="2" thousandSeparator="." decimalSeparator="," suffix={' min.'} value={totalDurationOperator} />                                            
                                       </div>
                                       <div className="col-1 col-sm-1 col-lg-1">
                                           <NumberFormat displayType="text" className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="2" thousandSeparator="." decimalSeparator="," suffix={' €'} value={totalCostOperator} />                                            
                                       </div>
                                       <div className="col-2 col-sm-2 col-lg-2"></div>

                         
                         </div>

    					  	            
    						      <div className="row text-muted" style={{marginTop: '10px',marginBottom: '20px'}}>
    					  	  
		    					  	          <div className="col-12 col-sm-12 col-lg-12" style={{paddingRight: '10px'}}>
    					  	  		            <input type="text" className="form-control col-12 col-sm-12 col-lg-12" {...formik.getFieldProps('lowerDescription')} placeholder={t('document.label.lowerDescription')} />
    					  	  		        </div>
                			</div>






                 









                        <div className="card-footer">
                            <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>     
                            <Button className="btn-default float-right" onClick={clearForm}>{t('general.button.clearForm')}</Button>                                                        	            	       			
                  			</div>



                      </form>
                  
                    
        </div>
    );
};



export default DocumentWorkOrderTab;